// @ts-strict-ignore
/* eslint-disable import/no-anonymous-default-export */
/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { ButtonLink } from './button-link-element'
import { gtmTrack } from '../utils/tracking'
import { timeout, useComponentTracking } from '../utils/component-events'

export default ({ text, link, ...props }) => {
  const { id, name, variant, size } = props
  const trackComponent = useComponentTracking()

  const onClick = (e) => {
    e.preventDefault()
    e.stopPropagation()

    gtmTrack('GA Button Clicked', 'Functional Interaction', `${text}`)
    timeout(trackComponent('Dynamic Component Event', 'CTAButtonClicked', { text })).then(() => {
      window.location.href = link
    })
  }

  return (
    <ButtonLink
      href={link}
      onClick={(e) => onClick(e)}
      size={size}
      id={id}
      name={name}
      variant={variant}
      data-click-tracking={JSON.stringify({
        component_category: 'button-link',
        component_id: id,
        component_name: 'ButtonLink',
        contentful_name: name,
        contentful_variant: variant,
        link_path: link,
        additionalProps: { text: text },
      })}
      {...props}
    >
      {text}
    </ButtonLink>
  )
}
